module.exports = __webpack_public_path__ + "static/img/hujiao.ed37da66.png";